<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="form"
      @submit="handleUpdate"
    >
      <Property
        :id="$route.params.id"
        :product="data"
        :propTrendingTags="trendingTags"
        ref="propertyForm"
      />
    </c-source-form>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { formColumns } from './columns';
import Property from './components/property';

@Component({
  components: { Property }
})
export default class ProductsEdit extends Vue {

  data = {}
  categories = [];
  trendingTags = [];

  get columns() {
    return formColumns({ categories: this.categories })
  }

  get form() {
    return {
      ...this.data,
      category_ids: (this.data.categories || []).map(item => item.id),
      related_product_ids: (this.data.related_products || []).map(item => item.id),
    }
  }

  async mounted() {
    const id = this.$route.params.id;
    const [data, { data: categories }, trendingTags] = await Promise.all([
      this.$request.get(`/products/${id}`),
      this.$request.get('/categories', { params: { per_page: 100, simple_list: true } }),
      this.$request.get('/tags', { params: { taggable_type: 'Trending' } }),
    ]);
    this.data = data;
    this.categories = categories;
    this.trendingTags = trendingTags;
  }

  async handleUpdate(data) {
    const propertyForm = this.$refs.propertyForm.submit();
    const body = {
      ...propertyForm,
      ...data,
      series_list: (data.series_list || []).join(','),
      category_ids: (data.category_ids || []).join(','),
      related_product_ids: data.related_products.map(item => item.id).join(',')
    }
    delete body.related_products;
    const id = this.$route.params.id;
    await this.$autoLoading(
      this.$request.put(`/products/${id}`, body)
    );
    this.$message.success('更新成功');
    this.$router.push({ name: 'products.show', params: { id } });
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .c-source-form .content {
    width: 100%;
    max-width: 1000px;
  }
</style>

